export const selectRoleRecord = (records, selectedRole, accountId) => {
  const normalizedRole = String(selectedRole ?? '').trim();
  const normalizedAccountId = String(accountId ?? '').trim();
  const validRecords = records.filter(
    (record) => record?.role_definition && typeof record.role_definition === 'object'
  );
  const exactMatch = validRecords.find((record) => (
    String(record.role_name ?? '').trim() === normalizedRole
    && String(record.account_id ?? '').trim() === normalizedAccountId
  ));

  return exactMatch || null;
};

export const buildUserAccessRefreshRequest = (userEmail, accountId) => ({
  user_email: userEmail,
  companyNumber: String(accountId ?? '').trim(),
});

export const buildRoleAccessRefreshRequest = (rawSelectedRole, accountId) => ({
  user_role: rawSelectedRole,
  account_id: accountId,
  companyNumber: String(accountId ?? '').trim(),
});

const accountTypeValue = (value) => {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (
    value
    && typeof value === 'object'
    && !Array.isArray(value)
    && typeof value.account_type === 'string'
  ) {
    return value.account_type.trim();
  }

  return '';
};

export const normalizeAccountDetails = (refreshedAccount, storedAccount, accountId) => {
  const refreshedDetails = (
    refreshedAccount
    && typeof refreshedAccount === 'object'
    && !Array.isArray(refreshedAccount)
  ) ? refreshedAccount : {};
  const storedDetails = (
    storedAccount
    && typeof storedAccount === 'object'
    && !Array.isArray(storedAccount)
  ) ? storedAccount : {};
  const normalizedType = accountTypeValue(refreshedAccount) || accountTypeValue(storedAccount);

  if (!normalizedType) {
    return null;
  }

  return {
    ...storedDetails,
    ...refreshedDetails,
    _id: refreshedDetails._id ?? storedDetails._id ?? accountId,
    account_type: normalizedType,
  };
};
